var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// components/layout/common/src/breakpoints.ts
var breakpointNames = ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"];
var breakpoints = {
  xs: {
    minWidth: 0,
    maxWidth: 599
  },
  sm: {
    minWidth: 600,
    maxWidth: 767
  },
  md: {
    minWidth: 768,
    maxWidth: 1023
  },
  lg: {
    minWidth: 1024,
    maxWidth: 1279
  },
  xl: {
    minWidth: 1280,
    maxWidth: 1439
  },
  xxl: {
    minWidth: 1440,
    maxWidth: 1599
  },
  xxxl: {
    minWidth: 1600,
    maxWidth: Number.MAX_VALUE
  }
};

// components/layout/common/src/adaptive/breakpoints.ts
import MobileDetect from "mobile-detect";
var DEFAULT_BREAKPOINTS = {
  xs: breakpoints.xs.maxWidth,
  sm: breakpoints.sm.maxWidth,
  md: breakpoints.md.maxWidth,
  lg: breakpoints.lg.maxWidth,
  xl: breakpoints.xl.maxWidth,
  xxl: breakpoints.xxl.maxWidth,
  xxxl: breakpoints.xxxl.maxWidth
};
function getBreakpointObject(breakpoint, components) {
  const c = components;
  const md = new MobileDetect(window.navigator.userAgent);
  if (md.mobile() && c.mobile) {
    return c.mobile;
  }
  switch (breakpoint) {
    case "xxxl":
      return c.xxxl || c.desktop || c.xxl || c.xl || null;
    case "xxl":
      return c.xxl || c.desktop || c.xl || c.lg || null;
    case "xl":
      return c.xl || c.desktop || c.lg || c.md || null;
    case "lg":
      return c.lg || c.desktop || c.tablet || c.md || c.xl || null;
    case "md":
      return c.md || c.tablet || c.phone || c.sm || c.lg || null;
    case "sm":
      return c.sm || c.phone || c.xs || c.md || null;
    case "xs":
      return c.xs || c.phone || c.sm || c.md || null;
    default:
      return c[breakpoint] || null;
  }
}
function getBreakpoint(breakpoints2, components, width) {
  const bpArray = Object.keys(breakpoints2).map((key) => ({
    key,
    value: breakpoints2[key]
  })).sort((a, b) => a.value - b.value);
  let bpIndex = -1;
  for (let i = bpArray.length - 1; i >= 0; i--) {
    if (width <= bpArray[i].value) {
      bpIndex = i;
    } else {
      break;
    }
  }
  if (bpIndex !== -1) {
    const bpKey = bpArray[bpIndex].key;
    const bpObj = getBreakpointObject(bpKey, components);
    if (bpObj.component) {
      return bpObj;
    }
  }
  return null;
}

// components/layout/common/src/box-style-sheet.ts
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var boxStyleSheet = new StyleSheet("box", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.box
  );
});
function createDefaultStyledClasses({ styles }) {
  return {
    root: __spreadValues({}, styles)
  };
}

// components/layout/common/src/col-style-sheet.ts
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";

// components/layout/common/src/container-props.ts
var defaultContainerProps = {
  density: "standard",
  maxWidth: 1280,
  noGutters: false
};

// components/layout/common/src/grid.ts
var grid = {
  // Compact is also referred to as Prosumer.
  compact: {
    xs: {
      margin: 8,
      gutter: 8,
      columns: 2
    },
    sm: {
      margin: 8,
      gutter: 8,
      columns: 6
    },
    md: {
      margin: 16,
      gutter: 8,
      columns: 8
    },
    lg: {
      margin: 16,
      gutter: 8,
      columns: 12
    },
    xl: {
      margin: 16,
      gutter: 8,
      columns: 12
    },
    xxl: {
      margin: 16,
      gutter: 8,
      columns: 12
    },
    xxxl: {
      margin: 16,
      gutter: 8,
      columns: 12
    }
  },
  // Standard is also referred to as Consumer.
  standard: {
    xs: {
      margin: 16,
      gutter: 8,
      columns: 2
    },
    sm: {
      margin: 16,
      gutter: 16,
      columns: 6
    },
    md: {
      margin: 24,
      gutter: 16,
      columns: 8
    },
    lg: {
      margin: 32,
      gutter: 24,
      columns: 12
    },
    xl: {
      margin: 32,
      gutter: 24,
      columns: 12
    },
    xxl: {
      margin: 32,
      gutter: 24,
      columns: 12
    },
    xxxl: {
      margin: 32,
      gutter: 24,
      columns: 12
    }
  },
  spacious: {
    xs: {
      margin: 16,
      gutter: 12,
      columns: 2
    },
    sm: {
      margin: 24,
      gutter: 16,
      columns: 6
    },
    md: {
      margin: 32,
      gutter: 24,
      columns: 8
    },
    lg: {
      margin: 40,
      gutter: 32,
      columns: 12
    },
    xl: {
      margin: 40,
      gutter: 32,
      columns: 12
    },
    xxl: {
      margin: 40,
      gutter: 32,
      columns: 12
    },
    xxxl: {
      margin: 40,
      gutter: 32,
      columns: 12
    }
  }
};

// components/layout/common/src/col-style-sheet.ts
var colStyleSheet = new StyleSheet2("col", (props) => {
  var _a;
  return createComponentClassDefinitions2(
    props,
    createDefaultStyledClasses2,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.col
  );
});
var widths = [
  "8.33333%",
  "16.66667%",
  "25%",
  "33.33333%",
  "41.66667%",
  "50%",
  "58.33333%",
  "66.66667%",
  "75%",
  "83.33333%",
  "91.66667%",
  "100%"
];
var rowColWidths = [
  "100%",
  "50%",
  "33.33333%",
  "25%",
  "20%",
  "16.66667%",
  "14.28571%",
  "12.5%",
  "11.11111%",
  "10%",
  "9.0909%",
  "8.33333%"
];
function getOrder(order) {
  if (order === "first") {
    return -1;
  } else if (order === "last") {
    return 13;
  } else if (order !== void 0) {
    return order;
  }
  return 12;
}
function getColSpanStyle(maxWidth) {
  return {
    flex: `0 0 ${maxWidth}`,
    maxWidth
  };
}
function getColAuto() {
  return {
    flex: "0 0 auto",
    width: "auto",
    maxWidth: "100%"
  };
}
function getColDefault() {
  return {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: "100%"
  };
}
function getStyleForBreakpoint(size, rowCols) {
  if (size !== void 0) {
    if (size === false) {
      return {};
    }
    if (size === "auto") {
      return getColAuto();
    }
    const sizeNum = +size;
    if (!isNaN(sizeNum) && sizeNum >= 1 && sizeNum <= 12) {
      return getColSpanStyle(widths[sizeNum - 1]);
    }
    if (typeof size === "object") {
      const { span, offset, order } = size;
      let styleSpan, styleOffset, styleOrder;
      if (span !== void 0) {
        if (span === "auto") {
          styleSpan = getColAuto();
        } else {
          const spanNum = +span;
          if (!isNaN(spanNum) && spanNum >= 1 && spanNum <= 12) {
            styleSpan = getColSpanStyle(widths[spanNum - 1]);
          }
        }
      }
      if (offset !== void 0 && offset >= 0 && offset <= 12) {
        styleOffset = {
          marginLeft: offset === 0 ? "0" : widths[offset - 1]
        };
      }
      if (order !== void 0) {
        styleOrder = {
          order: getOrder(order)
        };
      }
      if (styleSpan || styleOffset || styleOrder) {
        return __spreadValues(__spreadValues(__spreadValues({}, styleSpan || getColDefault()), styleOffset), styleOrder);
      }
    }
  }
  if (rowCols && rowCols !== "auto") {
    return getColSpanStyle(rowColWidths[rowCols - 1]);
  }
  return getColDefault();
}
function getBestSize(...sizes) {
  for (let i = 0; i < sizes.length; i++) {
    if (sizes[i] !== void 0) {
      return sizes[i];
    }
  }
  return void 0;
}
function getSizesAt({ xs, sm, md, lg, xl, xxl, xxxl }) {
  return {
    xs,
    sm: getBestSize(sm, xs),
    md: getBestSize(md, sm, xs),
    lg: getBestSize(lg, md, sm, xs),
    xl: getBestSize(xl, lg, md, sm, xs),
    xxl: getBestSize(xxl, xl, lg, md, sm, xs),
    xxxl: getBestSize(xxxl, xxl, xl, lg, md, sm, xs)
  };
}
function getColsAt({
  colsAtXs,
  colsAtSm,
  colsAtMd,
  colsAtLg,
  colsAtXl,
  colsAtXXl,
  colsAtXXXl
}) {
  return {
    colsAtXs,
    colsAtSm: colsAtSm || colsAtXs,
    colsAtMd: colsAtMd || colsAtSm || colsAtXs,
    colsAtLg: colsAtLg || colsAtMd || colsAtSm || colsAtXs,
    colsAtXl: colsAtXl || colsAtLg || colsAtMd || colsAtSm || colsAtXs,
    colsAtXXl: colsAtXXl || colsAtXl || colsAtLg || colsAtMd || colsAtSm || colsAtXs,
    colsAtXXXl: colsAtXXXl || colsAtXXl || colsAtXl || colsAtLg || colsAtMd || colsAtSm || colsAtXs
  };
}
function createDefaultStyledClasses2(_a) {
  var _b = _a, {
    breakpoints: breakpoints2 = breakpoints,
    density = defaultContainerProps.density,
    noGutters = defaultContainerProps.noGutters,
    grid: customGrid
  } = _b, sizeProps = __objRest(_b, [
    "breakpoints",
    "density",
    "noGutters",
    "grid"
  ]);
  const { colsAtXs, colsAtSm, colsAtMd, colsAtLg, colsAtXl, colsAtXXl, colsAtXXXl } = getColsAt(sizeProps);
  const { xs, sm, md, lg, xl, xxl, xxxl } = getSizesAt(sizeProps);
  const grid2 = customGrid || grid[density];
  const rootStyles = {
    display: "block",
    position: "relative",
    width: "100%",
    boxSizing: "border-box",
    "& > *": {
      boxSizing: "border-box"
    }
  };
  return {
    root: {
      [`@media (min-width:${breakpoints2.xs.minWidth})`]: xs !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.xs.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.xs.gutter * 0.5}px`
      }), getStyleForBreakpoint(xs, colsAtXs)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.sm.minWidth}px)`]: sm !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.sm.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.sm.gutter * 0.5}px`
      }), getStyleForBreakpoint(sm, colsAtSm)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.md.minWidth}px)`]: md !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.md.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.md.gutter * 0.5}px`
      }), getStyleForBreakpoint(md, colsAtMd)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.lg.minWidth}px)`]: lg !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.lg.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.lg.gutter * 0.5}px`
      }), getStyleForBreakpoint(lg, colsAtLg)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.xl.minWidth}px)`]: xl !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.xl.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.xl.gutter * 0.5}px`
      }), getStyleForBreakpoint(xl, colsAtXl)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.xxl.minWidth}px)`]: xxl !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.xxl.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.xxl.gutter * 0.5}px`
      }), getStyleForBreakpoint(xxl, colsAtXXl)) : {
        display: "none"
      },
      [`@media (min-width:${breakpoints2.xxxl.minWidth}px)`]: xxxl !== false ? __spreadValues(__spreadProps(__spreadValues({}, rootStyles), {
        paddingLeft: noGutters ? 0 : `${grid2.xxxl.gutter * 0.5}px`,
        paddingRight: noGutters ? 0 : `${grid2.xxxl.gutter * 0.5}px`
      }), getStyleForBreakpoint(xxxl, colsAtXXXl)) : {
        display: "none"
      }
    }
  };
}

// components/layout/common/src/container-style-sheet.ts
import { StyleSheet as StyleSheet3 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions3 } from "@gs-ux-uitoolkit-common/theme";
var containerStyleSheet = new StyleSheet3(
  "container",
  (props) => {
    var _a;
    return createComponentClassDefinitions3(
      props,
      createDefaultStyledClasses3,
      (_a = props.theme.styleOverrides) == null ? void 0 : _a.container
    );
  }
);
function createDefaultStyledClasses3({
  breakpoints: breakpoints2 = breakpoints,
  density = defaultContainerProps.density,
  maxWidth = defaultContainerProps.maxWidth,
  grid: customGrid
}) {
  const grid2 = customGrid || grid[density];
  return {
    root: {
      display: "block",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      maxWidth: maxWidth <= 0 || maxWidth >= Number.MAX_VALUE ? "100%" : `${maxWidth}px`,
      boxSizing: "border-box",
      "& > *": {
        boxSizing: "border-box"
      },
      [`@media (min-width:${breakpoints2.xs.minWidth})`]: {
        paddingLeft: `${grid2.xs.margin}px`,
        paddingRight: `${grid2.xs.margin}px`
      },
      [`@media (min-width:${breakpoints2.sm.minWidth}px)`]: {
        paddingLeft: `${grid2.sm.margin}px`,
        paddingRight: `${grid2.sm.margin}px`
      },
      [`@media (min-width:${breakpoints2.md.minWidth}px)`]: {
        paddingLeft: `${grid2.md.margin}px`,
        paddingRight: `${grid2.md.margin}px`
      },
      [`@media (min-width:${breakpoints2.lg.minWidth}px)`]: {
        paddingLeft: `${grid2.lg.margin}px`,
        paddingRight: `${grid2.lg.margin}px`
      },
      [`@media (min-width:${breakpoints2.xl.minWidth}px)`]: {
        paddingLeft: `${grid2.xl.margin}px`,
        paddingRight: `${grid2.xl.margin}px`
      },
      [`@media (min-width:${breakpoints2.xxl.minWidth}px)`]: {
        paddingLeft: `${grid2.xxl.margin}px`,
        paddingRight: `${grid2.xxl.margin}px`
      },
      [`@media (min-width:${breakpoints2.xxxl.minWidth}px)`]: {
        paddingLeft: `${grid2.xxxl.margin}px`,
        paddingRight: `${grid2.xxxl.margin}px`
      }
    }
  };
}

// components/layout/common/src/flex-style-sheet.ts
import { StyleSheet as StyleSheet4 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions4 } from "@gs-ux-uitoolkit-common/theme";
var flexStyleSheet = new StyleSheet4("flex", (props) => {
  var _a;
  return createComponentClassDefinitions4(
    props,
    createDefaultStyledClasses4,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.flex
  );
});
function createDefaultStyledClasses4({ styles }) {
  return {
    root: __spreadValues({}, styles)
  };
}

// components/layout/common/src/layout-context.ts
var defaultLayoutContext = {
  density: defaultContainerProps.density,
  noGutters: defaultContainerProps.noGutters
};

// components/layout/common/src/layout-density.ts
var layoutDensities = ["compact", "standard", "spacious"];

// components/layout/common/src/layout-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-layout";
var getColClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, `${globalClassName}-col`);
};
var getContainerClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, `${globalClassName}-container`);
};
var getRowClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, `${globalClassName}-row`);
};
var getOverlayContainerClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, `${globalClassName}-overlay-container`);
};
var getBoxClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, "gs-box");
};
var getFlexClassNames = (props) => {
  const { cssClasses, className } = props;
  return cx(cssClasses.root, className, "gs-flex");
};

// components/layout/common/src/overlay-container-style-sheet.ts
import { StyleSheet as StyleSheet5 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions5 } from "@gs-ux-uitoolkit-common/theme";
var overlayContainerStyleSheet = new StyleSheet5(
  "overlayContainer",
  (props) => {
    var _a;
    return createComponentClassDefinitions5(props, createDefaultStyledClasses5, (_a = props.theme.styleOverrides) == null ? void 0 : _a.overlayContainer);
  }
);
function createDefaultStyledClasses5(_props) {
  return {
    root: {
      display: "inline-block",
      position: "relative"
    }
  };
}

// components/layout/common/src/row-style-sheet.ts
import { StyleSheet as StyleSheet6 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions6 } from "@gs-ux-uitoolkit-common/theme";
var rowStyleSheet = new StyleSheet6("row", (props) => {
  var _a;
  return createComponentClassDefinitions6(
    props,
    createDefaultStyledClasses6,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.row
  );
});
function createDefaultStyledClasses6({
  breakpoints: breakpoints2 = breakpoints,
  density = defaultContainerProps.density,
  noGutters = defaultContainerProps.noGutters,
  grid: customGrid
}) {
  const grid2 = customGrid || grid[density];
  return {
    root: {
      display: "flex",
      flexWrap: "wrap",
      boxSizing: "border-box",
      "& > *": {
        boxSizing: "border-box"
      },
      [`@media (min-width:${breakpoints2.xs.minWidth})`]: {
        marginLeft: noGutters ? 0 : `${grid2.xs.gutter * -0.5}px`,
        marginRight: noGutters ? 0 : `${grid2.xs.gutter * -0.5}px`
      },
      [`@media (min-width:${breakpoints2.sm.minWidth}px)`]: {
        marginLeft: noGutters ? 0 : `${grid2.sm.gutter * -0.5}px`,
        marginRight: noGutters ? 0 : `${grid2.sm.gutter * -0.5}px`
      },
      [`@media (min-width:${breakpoints2.md.minWidth}px)`]: {
        marginLeft: noGutters ? 0 : `${grid2.md.gutter * -0.5}px`,
        marginRight: noGutters ? 0 : `${grid2.md.gutter * -0.5}px`
      },
      [`@media (min-width:${breakpoints2.lg.minWidth}px)`]: {
        marginLeft: noGutters ? 0 : `${grid2.lg.gutter * -0.5}px`,
        marginRight: noGutters ? 0 : `${grid2.lg.gutter * -0.5}px`
      },
      [`@media (min-width:${breakpoints2.xl.minWidth}px)`]: {
        marginLeft: noGutters ? 0 : `${grid2.lg.gutter * -0.5}px`,
        marginRight: noGutters ? 0 : `${grid2.lg.gutter * -0.5}px`
      }
    }
  };
}
export {
  DEFAULT_BREAKPOINTS,
  boxStyleSheet,
  breakpointNames,
  breakpoints,
  colStyleSheet,
  containerStyleSheet,
  defaultContainerProps,
  defaultLayoutContext,
  flexStyleSheet,
  getBoxClassNames,
  getBreakpoint,
  getBreakpointObject,
  getColClassNames,
  getContainerClassNames,
  getFlexClassNames,
  getOverlayContainerClassNames,
  getRowClassNames,
  grid,
  layoutDensities,
  overlayContainerStyleSheet,
  rowStyleSheet
};
//# sourceMappingURL=index.mjs.map
